import React, { useEffect, useState } from 'react';
import NewForm from 'components/NewForm';
import companyService from 'services/company.service';
import { formatDocument } from 'utils/format';
import fundService from 'services/fund.service';
import { formatMoneyByCurrency } from 'utils/currency'; 
import { useTranslation } from 'react-i18next';
import actionSubcategoryService from 'services/action.subcategory.service';
import ActionStatus from 'enums/ActionStatus';

export default function ActionData(props?:any){
  const [ action_id ] = useState(()=>{
    if(props.model) return props.model.id;
    return null;
  });

  function edit(n?:string){
    if(props.edit)return props.edit(n)
    return false;
  };
  const [ companiesList, setCompaniesList ] = useState<any[]>([]);
  const [ actionTypes, setActionTypes ] = useState<any[]>([]);
  const [ funds, setFunds ] = useState<any[]>([]);

  const { t } = useTranslation()

  useEffect(()=>{
    companyService.get({params:{
      fields:"id,name,document"
    }}).then((data)=>{
      setCompaniesList(data.map((item:any)=>{
        return {
          value:item.id,
          name:`${item.name} - ${formatDocument(item.document)}`
        }
      }))
    })

    actionSubcategoryService.get().then(data=>{
      setActionTypes(data.map((item:any)=>{
        return {name:item.name,value:item.id}
      }))
    })
  },[]);

  useEffect(()=>{
    if(props.model.company_id){
      fundService.get({params:{
        embed:"fund_type|payment_method",
        company_id:props.model.company_id
      }}).then((data)=>{
        setFunds((old:any[])=>{
            if(old.length > 0) return old;
            return data.map((item:any)=>{
            let value = parseFloat(item.value) - parseFloat(item.value_used);
            if(!!action_id){
              value += parseFloat(props.model.value);
            }
            return {
              value:item.id,
              name:`${item.fund_type.name} - ${item.payment_method.name} - ${formatMoneyByCurrency(value,1)}`
            }
          })
        })
      })
    }
  },[props.model.company_id, action_id, props.model.value])
  
  return (
    <>
      <NewForm title="Ação" className="mt-4">
        <NewForm.Select title={t("action:form:labels:type")} md="4" name="subcategory_id" state={props} options={[{value:"",name:"Selecione"},...actionTypes]}  disabled={!edit()}/> 
        <NewForm.SelectSearch title={t("action:form:labels:company")} md="4" name="company_id" state={props} options={[...companiesList]} disabled={!edit()}/>
        <NewForm.Date title={t("action:form:labels:start_date")} md="2" name="start_date" state={props}  disabled={!edit()} onChange={()=>{
          if(props.setModel) props.setModel((old:any)=>({...old,end_date:undefined}))
        }}/> 
        <NewForm.Date title={t("action:form:labels:end_date")} md="2" name="end_date" state={props} disabled={!edit() || !(props.model && props.model.start_date)} range={{min:(props.model && props.model.start_date)?props.model.start_date:null}}/> 
        <NewForm.Select title={t("action:form:labels:fund_id")} md="8" name="fund_id" state={props} disabled={!edit() || funds.length === 0} options={[{value:"",name:"Selecione"},...funds]}/>
        <NewForm.InputMoney title={t("action:form:labels:value")} md="4" name="value" state={props} disabled={!edit()}/>
      </NewForm>
      <NewForm title="Pagamento" className="mt-4" disabled={!(props && props.model && (props.model.action_status_id === ActionStatus.EmProcessodePagamento || props.model.action_status_id === ActionStatus.Concluido))}>
        <NewForm.Date title={t("action:form:labels:pay_date")} md="2" name="pay_date" state={props}  disabled={!edit("pay_date")}/> 
        <NewForm.Textarea title={t("action:form:labels:pay_observation")} md="12" name="pay_observation" state={props} disabled={!edit("pay_observation")}/>
      </NewForm>
      <NewForm>
        <NewForm.Files title={t("action:form:labels:anexo")} md="12" name="files" state={props} disabled={!edit("files")}/>
        <NewForm.Textarea title={t("action:form:labels:short_description")} md="12" name="description" state={props} disabled={!edit("description")}/>
      </NewForm>
    </>
  );
}